import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { SesssionActivityService } from '../../_services/sesssion-activity.service';
import { SessionActivityDataForm } from '../../_models/session-activity-data-form';
import { MatStepper } from '@angular/material';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { Router } from '@angular/router';
import { NavbarService } from '../../_services/navbar.service';

@Component({
  selector: 'app-learning-drawing',
  templateUrl: './learning-drawing.component.html',
  styleUrls: ['./learning-drawing.component.css']
})
export class LearningDrawingComponent implements OnInit {
  message: string;
  navItemSelected: string = '';
  learningTitle: string = '';
  userDataSession;
  userDetailsId = 0;
  stepperIndex: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();
  sessionActivity;
  percentage;

  @ViewChild('stepper') stepper: MatStepper;

  constructor(private router: Router,
    private sesssionActivityService: SesssionActivityService,
    private successDialogService: SuccessDialogService,
    private navbarService: NavbarService
  ) {}

  ngOnInit() {
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
    }
    this.getLastSessionAcgtivityBYUserId(this.userDetailsId, 2);
    this.getLearningPercentageDetails(this.userDetailsId);
  }
  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = " Patent drawing";
        break;
      case 2:
        this.message = " Types of Patent drawings";
        break;
      case 3:
        this.message = "Types of Patent drawings";
        break;
      case 4:
        this.message = " Drawing standards for Indian patent drawing";
        break;
      case 5:
        this.message = "Basic tools for patent drawing";
        break;
      default:
        break;
    }
  }

  getLastSessionAcgtivityBYUserId(userDetailId, activityType) {
    this.sesssionActivityService.getLastSessionActiityByUserId(userDetailId, activityType).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                setTimeout(() => {
                  this.stepper.selectedIndex = step.index;
                });
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }

  isSeenSecond = false;
  isSeenThird = false;
  isSeenFour = false;
  isSeenFive = false;
  isSeenSix = false;
  isSeenSeven = false;
  isSeenEight = false;

  moveNextIndex() {
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.activityType = 2
    const currentUser = localStorage.getItem('currentUser');
    this.sessionActivityDataForm.userDetails = JSON.parse(currentUser);
    switch (indexNumber) {
      case (2):
        if (!this.isSeenSecond) {
          this.isSeenSecond = true;
          this.sessionActivityDataForm.lastActivitySession = 2;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (3):
        if (!this.isSeenThird) {
          this.isSeenThird = true;
          this.sessionActivityDataForm.lastActivitySession = 3;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (4):
        if (!this.isSeenFour) {
         // console.log(indexNumber);
          this.isSeenFour = true;
          this.sessionActivityDataForm.lastActivitySession = 4;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (5):
        if (!this.isSeenFive) {
          this.isSeenFive = true;
          this.sessionActivityDataForm.lastActivitySession = 5;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      default:
        break;
    }
  }

  getLearningPercentageDetails(id) {
    this.sesssionActivityService.getLastSessionActiityPercentageByUserId(id).subscribe(
      resp => {
        this.percentage = resp;
      }, error => {
        console.log(error);
      })
  }

  moveToPatentSearch() {
    if (this.percentage.searchPercentage === null) {
      this.navbarService.saveActiveNavItem('Patent Search')
      this.successDialogService.successDialog(2);
    } else {
      this.navbarService.saveActiveNavItem('Patent Search')
      this.router.navigate(['/main/learning/learnPatentSearch']);
    }
  }
}
